import { Controller } from "@hotwired/stimulus"

// Card #4751 -- a tiny cross-controller trigger so a button OUTSIDE a
// review-actions instance's own DOM subtree can still open its dialog. The
// mission show page's Actions dropdown menu needs an "Approve plan and
// deploy" item that opens the SAME plan-approve modal the top-of-page plan
// Approve button already uses (Jay: one shared primitive, not a fork) --
// but the dropdown lives in a different part of the page to the plan
// review-actions block, and Stimulus actions only reach targets/methods
// within the SAME data-controller element (stimulus.md's "Scope Rule").
// Outlets are the documented escape hatch for exactly this (see
// deck_editor_controller.js's airdrop-report-viewer outlet).
export default class extends Controller {
  static outlets = ["review-actions"]

  approve() {
    if (this.hasReviewActionsOutlet) {
      this.reviewActionsOutlet.approve()
    }
  }
}
